<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-handy-notification"></div>
    </div>
    <h2>{{evaluateLanguageString(dialogData.title)}}</h2>
    <p>
      <span [innerHTML]="evaluateLanguageString(dialogData.description)"></span>
    </p>
    <ya-phone-number-input #phoneNumberInput></ya-phone-number-input>
    <div class="ya-dialog-action">
      <div class="ya-button-group-wrapper">
        <div class="ya-button-group-container">
          <div class="ya-button-container">
            <button mat-flat-button (click)="changePhoneNumber()"
              [disabled]="!phoneNumberInput.inputFormControl.valid||phoneNumberInput.inputFormControl.value===''">
              <span langkey="phChangePhoneNumber_Btn_Label"></span>
            </button>
            <div class="ya-button-container">
              <button mat-stroked-button (click)="cancelBtn()">
                <span langkey="phGlobal_Return"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>